module.exports = __webpack_public_path__ + "img/woman_dancing.be8c59eb.gif";